/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ForecastRequestDataItemFromJSON, ForecastRequestDataItemToJSON, TimeRangeFromJSON, TimeRangeToJSON, } from './';
export function ForecastRequestFromJSON(json) {
    return ForecastRequestFromJSONTyped(json, false);
}
export function ForecastRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        historyRange: TimeRangeFromJSON(json['historyRange']),
        forecastRange: TimeRangeFromJSON(json['forecastRange']),
        data: json['data'].map(ForecastRequestDataItemFromJSON),
    };
}
export function ForecastRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        historyRange: TimeRangeToJSON(value.historyRange),
        forecastRange: TimeRangeToJSON(value.forecastRange),
        data: value.data.map(ForecastRequestDataItemToJSON),
    };
}
